import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';
import { connect } from 'react-redux'
import Modal from '../../../basic-component/Modal'
import TakeAttendance from './TakeAttendance';
const $ = require('jquery');
require('jszip');
require('pdfmake');
$.DataTable = require('datatables.net-bs4');
// require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.flash.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.print.js');
require('datatables.net-keytable-bs4');
// require('datatables.net-responsive-bs4');
class Attendance extends Component {


    
    componentDidMount() {
        let attendanceData=this.props.attendanceData;
        this.$el = $(this.el);
        var table = this.$el.DataTable({
            // lengthChange: false,
            dom: 'lBfrtip',
            data: attendanceData,
            columns: [
                { data: 'roll' },
                { data: 'name' },
                { data: '1' },
                { data: '2' },
                { data: '3' },
                { data: '4' },
                { data: '5' },
                { data: '6' },
                { data: '7' },
                { data: '8' },
                { data: '9' },
                { data: '10' },
                { data: '11' },
                { data: '12' },
                { data: '13' },
                { data: '14' },
                { data: '15' },
                { data: '16' },
                { data: '17' },
                { data: '18' },
                { data: '19' },
                { data: '20' },
                { data: '21' },
                { data: '22' },
                { data: '23' },
                { data: '24' },
                { data: '25' },
                { data: '26' },
                { data: '27' },
                { data: '28' },
                { data: '29' },
                { data: '30' },
                { data: '31' },

            ],
            'rowCallback': function(row, data, index){
                
                let l=Object.keys(data).length;
                for(let i=1;i<=l;i++){
                    if(data[i]==="P"){
                        $(row).find('td:eq('+(i+1)+')').css('background-color', '#6fff73');
                    }
                    else if(data[i]==="A"){
                        $(row).find('td:eq('+(i+1)+')').css('background-color', '#ef6060');
                    }
                    else if(data[i]==="S"){
                        $(row).find('td:eq('+(i+1)+')').css('background-color', 'red');
                    }
                    else if(data[i]==="L"){
                        $(row).find('td:eq('+(i+1)+')').css('background-color', '#7c86fd');
                    }
                }
                },
            responsive:false,

            buttons: [
                // {
                //     extend: 'pdf',
                //     text: 'PDF',
                //     className: 'btn btn-success'
                // },
                {
                    extend: 'csv',
                    text: 'CSV',
                    title: "Students Records",
                    className: 'btn btn-success btn-sm'
                },
                {
                    extend: 'print',
                    text: 'Print',
                    title: "<h1 class='text-center'>Student Record</h1>",
                    className: 'btn btn-success btn-sm'
                }
            ]
        });
        table.buttons().container().appendTo(".export-buttons ");
        $('#myTable tbody').on('dblclick', 'tr', function () {
            var data = table.row(this).data();
            console.log(data);
            alert('You clicked on ' + data.name + '\'s row');
        });

    }

    render() {
        let attendanceTable = (<div>
            {/* <h2 className="text-secondary" style={{ paddingLeft: "0.5rem", paddingTop: "1rem" }}>Student</h2> */}
            <div className="card card-design-2">
                <div className="card-header bg-primary text-white">
                    Attendance List
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-4 col-sm-12">
                            <div className="row">
                                <div className="mr-1 pd-1"> Select Class</div>
                                <select className="form-control"><option>Std 1</option></select>
                            </div>
                        </div>
                        <div className="col-lg-8 col-sm-12 text-right export-buttons">
                            <button className="btn btn-primary btn-sm" data-toggle="modal" data-target="#myModal"><i className="fa fa-plus"></i> Take Attendance</button>&nbsp;
                            {/* <div className="export-buttons"></div> */}
                        </div>
                    </div>
                    <div className="row">
                    
                        
                        <div className=" table-responsive" style={{ padding: "10px" }}>
                            <table id="myTable" className="table table-hover table-bordered dt-responsive nowrap" width="100%" ref={el => this.el = el} >
                                <thead>
                                    <tr>
                                        <th>Roll No</th>
                                        <th>Name</th>
                                        <th>1</th>
                                        <th>2</th>
                                        <th>3</th>
                                        <th>4</th>
                                        <th>5</th>
                                        <th>6</th>
                                        <th>7</th>
                                        <th>8</th>
                                        <th>9</th>
                                        <th>10</th>
                                        <th>11</th>
                                        <th>12</th>
                                        <th>13</th>
                                        <th>14</th>
                                        <th>15</th>
                                        <th>16</th>
                                        <th>17</th>
                                        <th>18</th>
                                        <th>19</th>
                                        <th>20</th>
                                        <th>21</th>
                                        <th>22</th>
                                        <th>23</th>
                                        <th>24</th>
                                        <th>25</th>
                                        <th>26</th>
                                        <th>27</th>
                                        <th>28</th>
                                        <th>29</th>
                                        <th>30</th>
                                        <th>31</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
        return (
            <div>
                 <Modal header="Take Attendance" modalWidth="modal-md" modalId="myModal" action="Take Attendance"><TakeAttendance /></Modal>
                {/* <Modal header="Student Info" modalWidth="modal-xl" modalId="studentInfoModal" action="Update"><Student studentDetail={this.state.currentStudent} /></Modal> */}
                {attendanceTable}
                {/* <div>
                    <Switch>
                        <Route path="/Classes/AddClasses" component={AddClasses} />
                        <Route path="/Classes" exact render={() => classes} />
                    </Switch>

                </div> */}
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        isUserLoggedIn: state.isAuthenticated,
        attendanceData: state.attendanceData
    };
}
const mapDispatchToProps = dispatch => {
    return {
        addStudentToStore: (newStudent) => dispatch({ type: 'AddStudent', studentData: newStudent }),
        deleteStudentToStore: (roll) => dispatch({ type: "DeleteStudent", roll: roll })
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Attendance);
